export default __webpack_public_path__ + "static/media/powered.5f41b0aa.svg";